import IncomingPaymentMethod from '../models/IncomingPaymentMethod'
import OutgoingPaymentMethod from '../models/OutgoingPaymentMethod'

const state = {
    incoming_payment_methods: [],
    outgoing_payment_methods: []
};

const mutations = {
    'SET_INCOMING_PAYMENT_METHODS'(state, arg) {
        state.incoming_payment_methods = arg;
    },
    'SET_OUTGOING_PAYMENT_METHODS'(state, arg) {
        state.outgoing_payment_methods = arg;
    },
};

const actions = {
    async set_incoming_payment_methods({commit}) {
        try {
            let methods = await IncomingPaymentMethod.all(`sort=id%7Casc&page=1&per_page=999&filter=`)
            commit('SET_INCOMING_PAYMENT_METHODS', methods.data);
            return methods.data
        } catch (e) {
            return e
        }
    },

    async set_outgoing_payment_methods({commit}) {
        try {
            let methods = await OutgoingPaymentMethod.all(`sort=id%7Casc&page=1&per_page=999&filter=`)
            commit('SET_OUTGOING_PAYMENT_METHODS', methods.data);
            return methods.data
        } catch (e) {
            return e
        }
    },
};

const getters = {
    incoming_payment_methods: state => {
        return state.incoming_payment_methods;
    },
    outgoing_payment_methods: state => {
        return state.outgoing_payment_methods;
    },
};

export default {
    state,
    mutations,
    actions,
    getters
};
